import {
  GetAccountsInfo,
  PutAccountsInfo,
  PostAccountsInfo,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

const endPoint = 'accounts';

export const fetchAccountsInfo = async (): Promise<GetAccountsInfo> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const createAccountsInfo = async (
  targetAccountsInfo: PostAccountsInfo,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(targetAccountsInfo),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const updateAccountsInfo = async (
  targetAccountsInfo: PutAccountsInfo,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(targetAccountsInfo),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteAccountsInfo = async (
  accountsInfoKey: string,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('key', accountsInfoKey);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
